const DEFAULT_BASE_URL = 'http://40.172.139.118'
const DEFAULT_PAGE_SIZE = 10

// const DEFAULT_BACKEND_PORT = 8000

// our backend port
// const backend_port = process.env.REACT_APP_BACKEND_PORT
//  ? process.env.REACT_APP_BACKEND_PORT
//  : DEFAULT_BACKEND_PORT

// Shared Key Authentication is a custom authentication mechanism
// It ensures that only clients with a valid shared key can access the endpoints.
// in our case the endpoint is (rag_tools/get-openai-api-key/) to get open api key and tools
const DEFAULT_ML_SERVER_SHARED_KEY = '1234'
export const ML_MODEL = 'gpt-4o'

export const APP_ML_SERVER_SHARED_KEY =
  process.env.REACT_APP_ML_SERVER_SHARED_KEY
  ? process.env.REACT_APP_ML_SERVER_SHARED_KEY
  : DEFAULT_ML_SERVER_SHARED_KEY;


// const getChatbotCase = () => {
//   if (process.env.REACT_APP_CHATBOT_CASE && process.env.REACT_APP_CHATBOT_CASE === 'true') {
//     return true
//   } else {
//     return false
//   }
// }
// export const chatbotCase = getChatbotCase()
export const chatbotCase = true;


const logoPaths = {
  cloudKair: '',
  veritas: "/images/logo/veritas/black/full-black.png",
  sehteqArabia: '',
  speedyRecovery: "/images/logo/speedy-recovery/transparent-logo.png"
}
// to change the companiens name, make sure to update the env file.
export const companiesObject = {
  cloudKair: 'cloudKair',
  veritas: 'veritas',
  sehteqArabia: 'sehteqArabia',
  speedyRecovery: 'speedyRecovery'
}

export const company = process.env.REACT_APP_COMPANY_NAME ? process.env.REACT_APP_COMPANY_NAME : companiesObject.veritas

export const appLogoPath = logoPaths[company]

// our backend urls
export const urls = {
  // BASE_URL: `${process.env.REACT_APP_BASE_URL
  //   ? process.env.REACT_APP_BASE_URL
  //   : DEFAULT_BASE_URL}`
  //   + ":" + backend_port + '/',

  BASE_URL: `${process.env.REACT_APP_BASE_URL 
  ? process.env.REACT_APP_BASE_URL 
  : DEFAULT_BASE_URL}/`,
  
  LOGGED_USER: '/api/user/me',

  CREATE_A_PATIENT: '/api/user/patientprofile/create',
  SEARCH_FOR_PATIENT: '/api/user/patientprofiles?searchfor=',
  GET_A_PATIENT: '/api/user/patientprofile/',
  LIST_PATIENTS: '/api/user/patientprofiles',

  LIST_DIAGNOSES: '/api/medical/codes/icds',
  LIST_SEARCHED_DIAGNOSES: 'api/medical/codes/icds/search',
  LIST_SEARCHED_PROCEDURES: 'api/medical/codes/cpts/search',
  LIST_SEARCHED_DRUGS: 'api/medical/codes/drugs/search',

  GET_USER_ENCOUNTERS: '/api/patient/encounter/patientid/',
  CREATE_NEW_ENCOUNTER: '/api/patient/encounter/create/',
  LIST_ENCOUNTERS: '/api/patient/encounters/',
  GET_ENCOUNTER: '/api/patient/encounter',
  UPDATE_GET_ENCOUNTER: '/api/patient/encounter/',
  ANALYSIS_ENCOUNTERS:'/api/analysis/encounter_state',
  DOCTOR_PRICES:'/api/analysis/doctor_prices',
  DRUGS_COUNT:'/api/analysis/most_used_drugs',
  DRUGS_ISSUES:'/api/analysis/drug_issues',
  ICDS_COUNT:'/api/analysis/most_used_icds',
  ICDS_ISSUES:'/api/analysis/icd_issues',
  CPTS_COUNT:'/api/analysis/most_used_cpts',
  CPT_ISSUES:'/api/analysis/cpt_issues',
  APPROVAL_RATE:'/api/analysis/approval_rates',
  AVERAGE_COST:'/api/analysis/avg_costs',
  TOTAL_COSTS:'/api/analysis/total_costs',
  ENCOUNTER_EXPENSES:'/api/analysis/encounter_expenses',

  LIST_INSURANCES: '/api/insurance/insurances',
  LIST_FACILITIES:'/api/facility/facilities',
  
  UPLOAD_MRE: '/api/insurance/insurance/files/mreupload',
  DOWNLOAD_SAMPLE_PRICES_FILE: '/api/facility/facility/files/download/:fileType', // ---> file type is one of (icd, cpt, drug)
  DOWNLOAD_SAMPLE_PHARMACY_DRUGS_FILE: '/api/pharmacy/files/download/drug', // ---> this is for pharmacy drug file download
  GET_INSURNACS_ICD_PRICES: '/api/insurance/insurance/prices/icd',
  GET_INSURNACS_CPT_PRICES: '/api/insurance/insurance/prices/cpt',
  GET_INSURNACS_DRUG_PRICES: '/api/insurance/insurance/prices/drug',

  FACILITY_ICD_PRICES: '/api/facility/facility/prices/icd',
  FACILITY_CPT_PRICES: '/api/facility/facility/prices/cpt',
  FACILITY_DRUG_PRICES: '/api/facility/facility/prices/drug',

  PHARMACY_DRUG_PRICES: '/api/pharmacy/pharmacy-drug/upload',

  GET_PATIENT_Diagnosis: '/api/patient/encounter/icd/patientid/',
  GET_PATIENT_Procedures: '/api/patient/encounter/cpt/patientid/',
  GET_PATIENT_Medications: '/api/patient/encounter/drug/patientid/',

  ALTERNATIVE_DRUG_OPTIONS: '/api/medical/codes/drugs/drugalternatives/',
  CHANGE_PASSWORD: '/api/user/user/change_password',
  GENERATE_INVOICE: '/api/erpnext/generate_invoice',

  FAVOURITE : '/api/user/user/favourite/',
  NLP: '/api/patient/encounter/infer/create',
  SESSION_ID: '/api/chat/initialize',
  MESSAGE: 'api/chat/message/:sessionId', // ---> replace sessionId with the actual ID
  webSocket: `wss://:baseUrlws/voice/:sessionIdQuery`, // ---> replace sessionIdQuery with the actual ID
  LIST_PHARMACY: '/api/pharmacy/pharmacies',
  PHARMACY_DETAILS: '/api/pharmacy/pharmacy/:id',
  BASIC_STATS: '/api/analysis/basic_stat',
  FACILITY_BASIC_STATS: '/api/analysis/basic_stat/facility',
  INSURANCE_BASIC_STATS: '/api/analysis/basic_stat/insurnace',
  DOCTOR_LIST : '/api/user/doctorprofile/list_names',
  PATIENT_LIST : '/api/user/patientprofile/list_names',

  PENDING_REFILLS: '/api/analysis/drugs_pending_refills',
  CURRENT_REFILLS: '/api/analysis/drugs_refilled',
  UPCOMING_REFILLS: '/api/analysis/drugs_upcoming',
  ICD_ISSUES_TABLE: '/api/analysis/icd_issues_table',
  CPT_ISSUES_TABLE: '/api/analysis/cpt_issues_table',
  DRUG_ISSUES_TABLE: '/api/analysis/drug_issues_table',
  PATIENT_ABUSE_TABLE: '/api/analysis/patient_abuse_table',

  ENCOUNTER_REJECTION_DISTRIBUTION: '/api/analysis/encounter_rejection_distrubution',
  HIGH_DRUG_SPENDING: '/api/analysis/high_prescription_patients',
  EXPENSIVE_DRUG_PRESCRIBING_PROVIDERS: '/api/analysis/expensive_drug_prescription_doctors',
  PROVIDERS_WITH_HIGH_REJECTION_RATES: '/api/analysis/high_rejection_providers',
  PATIENTS_WITH_EXCESSIVE_ENCOUNTER_FREQUENCY: '/api/analysis/excessive_patient_visits',
  REFILL_TREND: '/api/analysis/refill_trend',

  FACILITY_DOCTOR_LIST: '/api/user/doctorprofile/',
  GET_SINGLE_DOCTOR_PROFILE: '/api/user/doctorprofile/get/:doctorID',
  CREATE_DOCTOR_PROFILE: '/api/user/doctorprofile/create',
  UPDATE_DOCTOR_PROFILE: '/api/user/doctorprofile/update/:doctorID',

  LIST_SCHEDULES: '/api/patient/schedules/', // GET => LIST SCHEDULES POST => CREATE A SCHEDULE
  UPDATE_SCHEDULE: '/api/patient/schedule/:id',
  // Pharmacy Drugs urls
  PHARMACY_DASHBOARD_STATS: '/api/pharmacy/dashboard-statistics',
  PHARMACY_PENDING_ENCOUNTERS: '/api/pharmacy/dispensing/queue/',
  DRUG_DISPENSING: '/api/pharmacy/dispensing/dispense/',
  GET_PHARMACY_DRUGS: '/api/pharmacy/pharmacy-drugs',
  // Lab Cpts urls
  LAB_QUEUED_ENCOUNTERS: '/api/lab/tests/queue/',
  LAB_TESTS_UPLOAD: '/api/lab/tests/upload/',
  LAB_DASHBOARD_STATS: '/api/lab/dashboard-statistics',
  LAB_TESTS_RESULTS: '/api/lab/tests/results/',
  LAB_ENCOUNTERS: '/api/lab/encounters/',

};

export const MAX_NUM_OF_DIAGNOSES = 10;
export const MIN_NUMBER_OF_SEARCH = 3;
export const MAX_NUM_OF_PROCEDURES = 10;
export const INITIAL_TREATMENTS_INPUT = 1;
export const MAX_NUM_OF_TREATMENTS = 10;
export const PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE ? process.env.REACT_APP_PAGE_SIZE : DEFAULT_PAGE_SIZE;
export const ENCOUNTER_SLICE_LENGTH = 5;

export const INITIAL_DIAGNOSIS_INPUT = [
  {
    index: 0,
    label: 'Primary Diagnosis',
    name: 'primary',
  },
  {
    index: 1,
    label: 'Secondary Diagnosis',
    name: 'secondary',
  },
];
export const INITIAL_PROCEDURES_INPUT = [
  {
    index: 0,
    label: 'Procedure 1',
    name: 'Procedure 0',
  },
];

export const INITIAL_TREATMENT_INPUT = [
  {
    index: 0,
    label: 'Treatment 1',
  },
];

export const INITIAL_TREATMENT_INPUT_VALUE = [
  {
    drug_dose: '',
    duration: '',
    frequency: '',
    drug_id: '',
    dosage_form: '',
    claimed_quantity: ''
  },
];

export const INITIAL_PATIENT_INSURANCE = {
  id: 1,
  name: "Out of Pocket",
  description: "Out of Pocket",
  register_id: "oop",
  use_mre: false
}

export const ENCOUNTER_ACTIONMSG = {
  Approved: 'Approved',
  Rejected: 'Rejected',
  Partially_accepted: 'Partially accepted',
  Pending_approval: 'Pending approval',
}

export const app_paths = {
  LOGIN_AUTH : '/login',
  NEW_PATIENT: '/new-patient',
  NEW_DOCTOR: '/new-doctor',
  UPDATE_PATIENT: '/update-patient/:patientID',
  NEW_ENCOUNTER: '/new-encounter/:patientID',
  NLP: '/nlp',
  PATIENT_PROFILE: '/patient/:patientID',
  DOCTOR_PROFILE: '/doctor/:doctorName',
  INSURANCE_ANALYSIS: '/insurance-analysis-page',
  SETTINGS: '/settings',
  INSURANCE_SETTINGS: '/insurance-settings',
  PATIENTS: '/patients',
  DOCTOR_LIST: '/doctor-list',
  DOCTOR_PROFILE_FOR_FACILITY: '/doctor-list/:doctorID',
  UPDATE_DOCTOR_PROFILE_FOR_FACILITY: '/update-doctor/:doctorID',
  PRICES_PAGE: '/prices',
  UPLOAD_PRICES_PAGE: '/upload-prices',
  DOCTOR_APPOINTMENT: '/appointment',
  PHARMACY_DRUGS: '/pharmacy-drugs',
  INVENTORY_PAGE: '/medicines-inventory',
  DISPENSED_MEDICINES: '/dispensing-medicines',
  PHARMACY_ENCOUNTER_HISTORY: '/encounter-history',
  LAB_TESTS_RESULTS: '/lab-test-results',
  LAB_ENCOUNTER_HISTORY: '/encounter-history',
}

export const reload_encounter = {
    FREQUENCY: 5000,
    DURATION: 120000
}

export const http_response_messages = {
  CREATE_ENCOUNTER: 'Encounter Created Successfuly',
  UPDATE_ENCOUNTER: 'Encounter is Updated',
  CREATE_PATIENT: 'Patient Added Successfully',
  UPDATE_PATIENT: 'Patient Updated Successfully',
  CREATE_DOCTOR: 'Doctor Added Successfully',
  UPDATE_DOCTOR: 'Doctor Updated Successfully',
  CHANGE_PASSWORD: 'Password Changed Successfully',
  ERROR: 'something went wrong!',
  CREATE_APPOINTMENT: 'Appointment Created Successfully',
  UPDATE_APPOINTMENT: 'Appointment Updated Successfully',
}

export const toastify_status = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info'
}

export const searchByStateButtons = [
  {
    name: 'Approved',
    color: 'success'
  },
  {
    name: 'Partially accepted',
    color: 'warning'
  },
  {
    name: 'Rejected',
    color: 'error'
  },
  {
    name: 'Canceled',
    color: 'info'
  },
]

export const patientFormType = {
  create: 'create',
  update: 'update'
}

export const SearchBarMenuItems = ({t, userRole, hide}) => {
  const menuItems = [
    {
      key: 1,
      label: t('Search.Date'),
      value: 'date',
      itemRoles: ['doctor', 'insurance_admin', 'facility_admin', 'patient', 'pharmacy_admin', 'lab_admin'],
      itemCompany: [companiesObject.veritas, companiesObject.speedyRecovery],
    },
    {
      key: 2,
      label: t('Search.ProviderName'),
      value: 'provider_name',
      itemRoles: ['insurance_admin', 'facility_admin', 'patient', 'pharmacy_admin', 'lab_admin'],
      itemCompany: [companiesObject.veritas, companiesObject.speedyRecovery],
    },
    {
      key: 3,
      label: t('Search.PatientName'),
      value: 'patient_name',
      itemRoles: ['insurance_admin', 'facility_admin', 'pharmacy_admin', 'lab_admin'],
      itemCompany: [companiesObject.veritas, companiesObject.speedyRecovery],
    },
    {
      key: 4,
      label: t('Search.ICDCode'),
      value: 'icd_code',
      itemRoles: ['doctor', 'insurance_admin', 'facility_admin', 'patient', 'pharmacy_admin', 'lab_admin'],
      itemCompany: [companiesObject.veritas, companiesObject.speedyRecovery],
    },
    {
      key: 5,
      label: t('Search.CPTCode'),
      value: 'cpt_code',
      itemRoles: ['doctor', 'insurance_admin', 'facility_admin', 'patient', 'lab_admin'],
      itemCompany: [companiesObject.veritas],
    },
    {
      key: 6,
      label: t('Search.DrugName'),
      value: 'drugname',
      itemRoles: ['doctor', 'insurance_admin', 'facility_admin', 'patient', 'pharmacy_admin'],
      itemCompany: [companiesObject.veritas, companiesObject.speedyRecovery],
    },
    {
      key: 7,
      label: t('Search.State'),
      value: 'state',
      itemRoles: ['doctor', 'insurance_admin', 'facility_admin', 'patient', 'pharmacy_admin', 'lab_admin'],
      itemCompany: [companiesObject.veritas, companiesObject.speedyRecovery],
    },
  ];

  const filteredMenuItems = menuItems.filter(
    (item) => item.itemCompany.includes(company) && item.itemRoles.includes(userRole) && !item.value.includes(hide)
  );

  return filteredMenuItems;
};

export const sliderImages = () => {
  const images = [
    { url: 'images/sliderImages/image1.png', usedCompany: [companiesObject.veritas, companiesObject.speedyRecovery] },
    { url: 'images/sliderImages/image2.png', usedCompany: [companiesObject.veritas] },
    { url: 'images/sliderImages/image3.png', usedCompany: [companiesObject.veritas, companiesObject.speedyRecovery] },
  ];

  const filteredSliderImages = images.filter((image) => image.usedCompany.includes(company))
  return filteredSliderImages
}

export const pricesFileIndicators = () => {
  const indicators = [
    {title: 'Icd', value:"icd_file", label:"ICD File", role: ['facility_admin', 'insurance_admin'], usedCompany: [companiesObject.veritas, companiesObject.speedyRecovery]},
    {title: 'Cpt', value:"cpt_file", label:"CPT File", role: ['facility_admin', 'insurance_admin'], usedCompany: [companiesObject.veritas]},
    {title: 'Drug', value:"drug_file", label:"DRUG File", role: ['facility_admin', 'insurance_admin'], usedCompany: [companiesObject.veritas, companiesObject.speedyRecovery]},
    {title: 'Pharmacy Drug', value:"pharmacy_drug_file", role: ['pharmacy_admin'], label:"Pharmacy DRUG File", usedCompany: [companiesObject.veritas, companiesObject.speedyRecovery]},
  ]

  const filteredIndicators = indicators.filter((indicator) => indicator.usedCompany.includes(company))
  return filteredIndicators
}

// Basic Statistics Titles
  export const statsTitles = {
    total_expenditure: 'Approved Claims Cost',
    total_encounters: 'Total encounters',
    avg_cost: 'Avg. Cost Per Encounter',
    total_patients: 'Active Patients',
    active_doctors: 'Active doctors',
    top_drug: 'Top Drug',
    money_saved: 'Rejected Claims Cost',
    rejected_icds: 'Rejected Diagnosis',
    rejected_cpts: 'Rejected Procedures',
    rejected_drugs: 'Rejected Drugs',
    approved_ratio: 'Approved Ratio',
    total_patient_not_refile_yet: 'Overdue Refills',
    total_cost_on_upcoming_refiles: 'Upcoming Refill Cost',
    total_patient_who_refile_this_month: 'Refills This Month',
    expensive_drugs_prescribed: 'Expensive Drugs',
    patient_abusing_system: 'Potential Patients Abuse',
    high_rejection_providers: 'Flagged Providers',
    excessive_encounters: 'Excessive Visits',
  };

  export const departmentLabel = {
    INTERNAL_MEDICINE: "Internal Medicine",
    SURGERY: "Surgery",
    PEDIATRICS: "Pediatrics",
    OB_GYN: "Ob Gyn",
    EMERGENCY: "Emergency",
    RADIOLOGY: "Radiology",
    PATHOLOGY: "Pathology",
    ANESTHESIOLOGY: "Anesthesiology",
    FAMILY_MEDICINE: "Family Medicine",
    OTHER: "Other"
  }

  export const divisionLabel = {
    OUTPATIENT: "Outpatient",
    INPATIENT: "Inpatient",
    CRITICAL_CARE: "Critical Care",
    DIAGNOSTICS: "Diagnostics",
    REHABILITATION: "Rehabilitation",
    RESEARCH: "Research",
    ADMINISTRATION: "Administration",
    OTHER: "Other"
  }